module.exports = __webpack_public_path__ + "static/media/logo.655a1957.png";